import CoreEvent from '@/core/event/coreEvent';

class ViewportEvents extends CoreEvent {

    constructor(type, data) {
        super(type, data);
    }

    static get RESIZE() {
        return 'ViewportEvents.resize';
    }

    static get DELAYED_RESIZE() {
        return 'ViewportEvents.delayedResize';
    }

    static get BREAKPOINT_CHANGE() {
        return 'ViewportEvents.breakpointChange';
    }

    static get ORIENTATION_CHANGE() {
        return 'ViewportEvents.orientationChange';
    }
}

export default ViewportEvents;
